function DDUMainSpeed({value}) {
    return (
        <div className="flex bg-white w-full rounded-[6px] justify-center items-center">
            <h3 className="font-bold text-black text-[20px]">{Math.trunc(value.speed)}</h3>
        </div>
    );
}

export default DDUMainSpeed;